import { render, staticRenderFns } from "./TrainingComponent.vue?vue&type=template&id=6900ea23&"
import script from "./TrainingComponent.vue?vue&type=script&lang=js&"
export * from "./TrainingComponent.vue?vue&type=script&lang=js&"
import style0 from "./TrainingComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports